import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from './DataModel/AppModel';
import RuiHeader from './components/RuiHeader';
import RuiNavigation from './components/RuiNavigation';
import LoggedOutPage from './pages/LoggedOutPage';
import * as LoginHelper from './utils/LoginHelper';
import Snackbar from 'material-ui/Snackbar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Events from './utils/events';
import PageLoading from './components/PageLoading';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';

import DeconxTheme from './utils/DeconxTheme';
import ImpersonateTheme from './utils/ImpersonateTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

let deconxTheme = getMuiTheme(DeconxTheme);
let impersonateTheme = getMuiTheme(ImpersonateTheme);

import { clearUIMessage,showTemporaryUIMessage } from './utils/UIMessageBoxes';

import DevTools from 'mobx-react-devtools';

export default @observer class AppLayout extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  closeUIErrorMessage() {
    AppModel.uiError=null;
  }

  error_actions = [
    <FlatButton
      label="OK"
      primary={true}
      onTouchTap={this.closeUIErrorMessage} />,
  ];

  componentWillMount() {
    if(!AppModel.loggedIn) {
      LoginHelper.login(this.context.router);
    }
  };

  _updateDeviceSize() {
    AppModel.uiSession.deviceWidth = window.innerWidth;
    AppModel.uiSession.deviceHeight = window.innerHeight;
    AppModel.uiSession.pixelRatio = window.devicePixelRatio || 1;
  };

  componentDidMount() {
    this._updateDeviceSize();
    Events.on(window, 'resize', this._updateDeviceSize);
  };

  componentWillUnmount() {
    Events.off(window, 'resize', this._updateDeviceSize);
  };

  closeUIMessage() {
    clearUIMessage();
  };

  actionUIMessage() {
    let action = AppModel.uiUndoAction;
    clearUIMessage();
    // Post execution of the undo action till after the event handling of
    // this click (to allow the UI Message pop over to disappear meanwhile)
    if(action) setTimeout(()=>{
      action();
    },0);
  };

  loggedOutVersion(sizeStyle) {
    let colorTheme = deconxTheme;
    if(!!AppModel.isImpersonated) {
      colorTheme = impersonateTheme;
    }

    return (
      <MuiThemeProvider muiTheme={colorTheme}>
        <div>
          <RuiHeader />
          <RuiNavigation />
          <div style={sizeStyle}>
            <PageLoading loading={AppModel.fetchingUserProfile}>
              <LoggedOutPage />
            </PageLoading>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }

  relogin() {
    var history = this.context.router;
    LoginHelper.logout(history);
    LoginHelper.login(history);
  }

  resendConfirmationEmail() {
    LoginHelper.resendVerificationEmail()
    .then( ()=> {
      showTemporaryUIMessage("New verification email sent");
    })
  }


  registrationFlow(sizeStyle) {
    return (
      <MuiThemeProvider muiTheme={deconxTheme}>
      <div>
        <RuiHeader />
        <Card style={{padding:'24px',margin:'24px'}}>
          <CardTitle
            title={(<div>Logged in as <b>{AppModel.login_email}</b></div>)}
          />
        {AppModel.login_email_verified? null : (
          <CardText>
            Your email address needs to be verified.  Check your inbox for a
            confirmation email and follow the instructions in it.
          </CardText>
        ) }
        {AppModel.missingUserProfile? (
          <CardText>
            This application requires an administrator to grant you access.
            Inform your administrator about the email address above.
            <br></br><br></br>
            When your admin have added your account to the system, Log back
          in.
          </CardText>
        ) : null } 
        <CardActions>
          <RaisedButton label="Log out" primary={true}
                      onTouchTap={this.relogin.bind(this)}  />
          <FlatButton secondary={true} label="Send new confirmation email"
              onTouchTap={this.resendConfirmationEmail.bind(this)}  />
        </CardActions>
        </Card>

        <Snackbar
          open={!!AppModel.uiMessage}
          message={AppModel.uiMessage || ""}
          action={AppModel.uiUndoAction ? "UNDO" : "OK" }
          onActionTouchTap={this.actionUIMessage}
          onRequestClose={this.closeUIMessage}
        />
        </div>
      </MuiThemeProvider>
    );
  }

  render() {
    // For some reason, the device width and height is not reported correctly
    // before the first render (it seems)
    // So this is a hack to try to capture the right sizes, it does not seem
    // to trigger too many unneccessary _updateDeviceSize calls
    let colorTheme = deconxTheme;
    setTimeout(() => {
      this._updateDeviceSize();
    },10);
    var sizeStyle={};
    if(AppModel.uiSession.fixedNavigation) {
      sizeStyle={'marginLeft':'256px'};
    }
    if(!AppModel.loggedIn) {
      return this.loggedOutVersion(sizeStyle);
    }
    if(AppModel.missingUserProfile || !AppModel.login_email_verified) {
      return this.registrationFlow();
    }
    if(!!AppModel.isImpersonated) {
      colorTheme = impersonateTheme;
    }
    if(AppModel.uiSession.fullScreen) {
      return (
        <MuiThemeProvider muiTheme={colorTheme}>
        <div>
          {this.props.children}
        </div>
      </MuiThemeProvider>
      )
    }
    return (
      <MuiThemeProvider muiTheme={colorTheme}>
      <div>
        <RuiHeader />
        <Dialog
          title="Error"
          actions={this.error_actions}
          modal={true}
          open={AppModel.uiError!=null}>
          {AppModel.uiError}
        </Dialog>
        <RuiNavigation />
        <div style={sizeStyle}>
          <PageLoading loading={AppModel.fetchingUserProfile}>
            {this.props.children}
          </PageLoading>
        </div>
        <Snackbar
          open={!!AppModel.uiMessage}
          message={AppModel.uiMessage || ""}
          action={AppModel.uiUndoAction ? "UNDO" : "OK" }
          onActionTouchTap={this.actionUIMessage}
          onRequestClose={this.closeUIMessage}
        />
      {AppModel.node_env()=="development" ? (<DevTools />) : null}
    </div>
    </MuiThemeProvider>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/AppLayout.jsx
 **/